import React from "react";
import { useDispatch } from "react-redux";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { savePlantillaCuestionariosOpciones } from "../../../../redux/climalaboral/plantillaCuestionario/action";

const RespuestaOtro = (props) => {
  const dispatch = useDispatch();

  const nuevaOpcion = () => {
    var req = {
      respuesta: `Opción ${props.nombreOpcion}`,
      pregunta: props.id,
      valor: 1,
      posicion: parseInt(props.nombreOpcion - 1),
    };
    dispatch(
      savePlantillaCuestionariosOpciones(
        req,
        props.setLoader,
        props.opciones,
        props.setOpciones
      )
    );
  };

  return (
    <Form.Group>
      <Row>
        <Form.Group as={Col} className="mb-3" sm="12" md="12" lg="12" xl="12">
          {(props.tipo.toLowerCase() === "MENU DESPLEGABLE".toLowerCase() ||
            props.tipo.toLowerCase() === "OPCIÓN MÚLTIPLE".toLowerCase() ||
            props.tipo.toLowerCase() ===
              "CASILLAS DE VERIFICACIÓN".toLowerCase()) && (
            <Row className="pl-3 pr-3">
              <Col
                xs="1"
                sm="1"
                md="1"
                lg="1"
                xl="1"
                className="d-flex flex-wrap justify-content-center align-items-center"
              >
                <Row className="flex-wrap justify-content-center align-items-center">
                  <span className="a flex-wrap justify-content-center align-items-center buttonGrab">
                    <i
                      className="material-icons dragI"
                      style={{
                        color: "#495057",
                        borderRight: "1px solid #ced4da",
                      }}
                    >
                      drag_indicator
                    </i>
                  </span>
                  <span className="flex-wrap justify-content-center align-items-center">
                    <div style={{ color: "#495057" }}></div>
                    {props.icono}
                  </span>
                </Row>
              </Col>
              <Col xs="7" sm="7" md="7" lg="7" xl="7">
                {props.loader ? (
                  <Spinner
                    className="mr-2"
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <Row>
                    <Col
                      className="pl-0 pr-0 ml-3 mr-3 rounded-pill d-flex flex-wrap justify-content-left align-items-center"
                      style={{ border: "1px solid #ced4da", overflowX: "auto" }}
                    >
                      <Button
                        variant="light"
                        className="btn-block anadir"
                        onClick={nuevaOpcion}
                        disabled={props.loader}
                      >
                        Añadir opción
                      </Button>
                      {/* <h6 style={{marginBottom:'0',color:'#ced4da'}}>ó</h6> */}
                      {/* <Link className='btn btn-outline-light anadir'>Añadir respuesta "otro"</Link> */}
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          )}
          {/* {props.tipo.toLowerCase() ===
            "Matriz/escala valoración".toLowerCase() && (
            <Row>
              <Col xs="6" sm="6" md="6" lg="6" xl="6">
                <Row>
                  <Col
                    className="pl-0 pr-0 ml-3 mr-3 rounded-pill d-flex flex-wrap justify-content-between align-items-center"
                    style={{ border: "1px solid #ced4da", overflowX: "auto" }}
                  >
                    <Link
                      className="btn btn-outline-light anadir"
                      onClick={nuevaOpcion}
                    >
                      Agregar rangos
                    </Link>
                  </Col>
                </Row>
              </Col>
            </Row>
          )} */}
        </Form.Group>
      </Row>
    </Form.Group>
  );
};

export default withRouter(RespuestaOtro);
